/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Grid,
  InputAdornment,
  TextField,
  LinearProgress,
  Typography,
  Snackbar,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import DownloadIcon from "@mui/icons-material/Download";
import "./style.css";
import { ZyppLiteApi } from "../../../API/Zypp-Lite-Api/LiteApi";
import { downloadReport } from "../../utils/downloadReport";
const FleetDailyReport = () => {
  const [searchValInput, setSearchValInput] = useState("");
  const [page, setPage] = useState(0);
  const [totalCount, setTotalCount] = useState<any>();
  const [readyAllotmentListData, setReadyAllotmentListData] = useState<any[]>([]);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [showErrorSnackbar, setShowErrorSnackbar] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedPlan, setSelectedPlan] = useState<any>(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState<"success" | "error">(
    "success"
  );
  const [downloading, setDownloading] = useState(false);
  const [editData, setEditData] = useState<any>(null);
  
  const [editForm, setEditForm] = useState({
    imei: "",
    bleMac: "",
    msisdn: "",
    iotType: "",
  });

  const rowsPerPage = 10;
  const pageRange = 5;
  const tableHeaderCellStyle = {
    fontWeight: 600,
    fontSize: "14px",
    color: "#455A64",
    font: "Rubik",
  };
  const tableBodyCellStyle = {
    fontWeight: 400,
    fontSize: "14px",
    color: "#3b3b3b",
    font: "Rubik",
  };
  // Dummy data for tables

  const pageCount = Math.ceil(totalCount / rowsPerPage);

  const handlePageChange = (newPage: number) => {
    const newPageNumber = Math.max(1, Math.min(newPage + 1, pageCount));
    setPage(newPageNumber - 1);
  };

  
  
  const renderPageNumbers = () => {
    const pagesToShow = Math.min(pageCount, pageRange);
    const startPage = Math.max(
      0,
      Math.min(page - Math.floor(pageRange / 2), pageCount - pagesToShow)
    );

    return Array.from({ length: pagesToShow }, (_, index) => {
      const pageNumber = startPage + index + 1;
      return (
        <span
          key={index}
          onClick={() => handlePageChange(pageNumber - 1)}
          className={page === pageNumber - 1 ? "active" : "unactive"}
          style={{ marginLeft: "6px" }}
        >
          {pageNumber}
        </span>
      );
    });
  };

  const handleClearSearch = () => {
    setSearchValInput("");
  };

  const handleDownloadReport = () => {
    downloadReport(
      () => ZyppLiteApi.api.downloadRfaVehiclesReport(),
      "Ready_For_Allotment_Report.xlsx",
      (msg) => { setSnackbarMessage(msg); setSnackbarSeverity("success"); setShowErrorSnackbar(true); },
      (msg) => { setSnackbarMessage(msg); setSnackbarSeverity("error"); setShowErrorSnackbar(true); },
      setDownloading
    );
  };

  const downloadRC = (item: any) => {
    ZyppLiteApi.api
      ?.downloadDocumentRc(item.vehicleId)
      .then((response) => {
        if (response?.code === 2000 && response?.data?.downloadLink) {
          window.open(response.data.downloadLink, "_blank");
          setSnackbarSeverity("success");
        } else if (response?.code === 400) {
          setSnackbarMessage("RC Document Not Found");
          setShowErrorSnackbar(true);
          setSnackbarSeverity("error");
        } else {
          setSnackbarSeverity("error");
          setSnackbarMessage(
            response?.message || "Error downloading RC document"
          );
          setSnackbarSeverity("error");
          setShowErrorSnackbar(true);
        }
      })
      .catch((error) => {
        console.error("Download RC error: ", error);
        setSnackbarMessage("Failed to download RC document");
        setShowErrorSnackbar(true);
        setSnackbarSeverity("error");
      });
  };
  const fetchUserData = () => {
    ZyppLiteApi.api
      ?.readyAllotmentList(searchValInput, page, rowsPerPage)
      .then((response) => {
        if (response.data.vehicleDetails.length > 0) {
          setReadyAllotmentListData(response.data.vehicleDetails);
          setTotalCount(response.data.total);
        } else {
          setReadyAllotmentListData([]);
          setTotalCount(1);
        }
      })
      .catch((error) => {
        console.error("API call error: ", error);
      });
  };
  useEffect(() => {
    fetchUserData();
  }, [page, rowsPerPage, searchValInput]);

  

  const handlePlanStatusUpdate = (userId: number, planStatus: string) => {
    const payload = {
      userId,
      planStatus,
    };

    ZyppLiteApi.api
      ?.verifyRentalPlan(payload)
      .then((response: any) => {
        if (response?.code === 2000) {
          setSnackbarMessage("Plan status updated successfully");
          setShowErrorSnackbar(true);
          setSnackbarSeverity("success");
          setAnchorEl(null); // Close popper
          setSelectedPlan(null);
          fetchUserData();
        } else {
          setSnackbarMessage(response?.message || "Plan update failed");
          setSnackbarSeverity("error");
          setShowErrorSnackbar(true);
        }
      })
      .catch((error) => {
        console.error("Plan status update error:", error);
        setSnackbarSeverity("error");
        setSnackbarMessage("Plan update failed");
        setShowErrorSnackbar(true);
      });
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (anchorEl && !anchorEl.contains(event.target as Node)) {
        setAnchorEl(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [anchorEl]);
 const handleUpdateIoTDetails = () => {
    if (!editData) return;

    const payload = {
      bleMac: editForm.bleMac,
      msisdn: editForm.msisdn,
      iotType: Number(editForm.iotType),
      vehicleId: editData.vehicleId,
      newImei: editForm.imei,
    };

    ZyppLiteApi.api
      ?.updateVehicleIoT(payload)
      .then((response: any) => {
        if (response?.code === 2000) {
          setSnackbarMessage("Vehicle IoT details updated successfully");
          setShowErrorSnackbar(true);
          setSnackbarSeverity("success");
          fetchUserData();
          setEditData(null);
        } else {
          setSnackbarMessage(response?.message || "Update failed");
          setShowErrorSnackbar(true);
          setSnackbarSeverity("error");
        }
      })
      .catch((error: any) => {
        console.error("Error during approval:", error);

        const message =
          error?.response?.data?.message ||
          error?.message ||
          "An unexpected error occurred";

        setSnackbarMessage(message);
        setSnackbarSeverity("error");
        setShowErrorSnackbar(true);
      });
  };
  return (
    <div className="p-10">
      <div className="w-full flex bg-white min-h-80 box-shadow p-3 rounded-xl">
        <div className="w-full">
          <Grid container spacing={5} className="w-full flex justify-between ">
            <Grid item md={4}>
              <div className="flex ml-4">
                <h2 className="text-center ml-2 mx-1 mt-2 font-semibold text-2xl text-black pb-2">
                 Ready For Allotment List
                </h2>
              </div>
            </Grid>
            <Grid item md={8}>
              <div className="flex mr-4">
                <div className="flex w-full justify-end">
                  <div className="mr-3">
                    <TextField
                      placeholder="Search EV No"
                      id="outlined-basic"
                      variant="outlined"
                      onChange={(search: any) =>
                        setSearchValInput(search.target.value)
                      }
                      value={searchValInput}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                        endAdornment: (
                          <InputAdornment
                            position="end"
                            onClick={handleClearSearch}
                          >
                            <ClearIcon style={{ cursor: "pointer" }} />
                          </InputAdornment>
                        ),
                        style: {
                          height: "40px",
                          borderRadius: "25px",
                          width: "350px",
                        },
                      }}
                    />
                  </div>

                  <Button
                    onClick={handleDownloadReport}
                    disabled={downloading}
                    style={{
                      backgroundColor: "#06B681",
                      padding: "5px 18px",
                      color: "#fff",
                      borderRadius: "40px",
                      textTransform: "none",
                      fontSize: "16px",
                    }}
                  >
                    <DownloadIcon sx={{ mr: 0.5 }} />
                    {downloading ? "Downloading..." : "Download"}
                  </Button>
                </div>
              </div>
            </Grid>
          </Grid>
          <hr className="my-4" />

          <TableContainer>
            {!readyAllotmentListData ? ( // Check if API response is still undefined (loading)
              <LinearProgress />
            ) : typeof readyAllotmentListData === "string" ? ( // If API returns "No Data Found" as a string
              <Typography style={{ textAlign: "center", padding: "10px" }}>
                No data available
              </Typography>
            ) : readyAllotmentListData.length === 0 ? ( // If the array is empty
              <Typography style={{ textAlign: "center", padding: "10px" }}>
                No data available
              </Typography>
            ) : (
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell
                      style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                      sx={{ minWidth: 120 }}
                    >
                      Vehicle No
                    </TableCell>
                    <TableCell
                      style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                      sx={{ minWidth: 120 }}
                    >
                      Fleet Age Type
                    </TableCell>
                    <TableCell
                      style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                      sx={{ minWidth: 150 }}
                    >
                      IMEI No.
                    </TableCell>
                   
                    <TableCell
                      style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                      sx={{ minWidth: 120 }}
                    >
                      Fleet Speed Type
                    </TableCell>
                    <TableCell
                      style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                      sx={{ minWidth: 110 }}
                    >
                    Vehicle Docs
                    </TableCell> 

                   
                  </TableRow>
                </TableHead>
                <TableBody>
                  {readyAllotmentListData.map((item: any, index: any) => (
                    <TableRow key={index}>
                      <TableCell
                        style={{ ...tableBodyCellStyle, textAlign: "center" }}
                      >
                        {item.vehicleNo ? item.vehicleNo : "_"}
                      </TableCell>
                      <TableCell
                        style={{ ...tableBodyCellStyle, textAlign: "center" }}
                      >
                        {item.fleetAgeType ? item.fleetAgeType : "_"}
                      </TableCell>
                      <TableCell
                        style={{ ...tableBodyCellStyle, textAlign: "center" }}
                      >
                        {item.imei}  <EditIcon
                          sx={{ color: "#00CD5B", cursor: "pointer" }}
                          onClick={() => {
                            setEditData(item);
                            setEditForm({
                              imei: item.imei || "",
                              bleMac: item.bleMac || "",
                              msisdn: item.msisdn || "",
                              iotType: item.iotType || "",
                            });
                          }}
                        />
                      </TableCell>

                      
                       <TableCell
                        style={{ ...tableBodyCellStyle, textAlign: "center" }}
                      >
                        {item.fleetSpeedType ? item.fleetSpeedType : "_"}
                      </TableCell>

                    <TableCell
                        style={{ ...tableBodyCellStyle, textAlign: "center" }}
                      >
                        <img
                          src={"/assets/document.svg"}
                          alt="document"
                          onClick={() => downloadRC(item)}
                          style={{
                            cursor: "pointer",
                            display: "block",
                            margin: "auto",
                          }}
                        />
                      </TableCell>
                     
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            )}
          </TableContainer>

          <div className="pl-2 pt-4 pb-2 pr-16">
            <div
              className="pagination"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <div>
                <button
                  onClick={() => handlePageChange(page - 1)}
                  disabled={page === 0}
                  style={{
                    fontFamily: "Rubik",
                    fontSize: "20px",
                    marginRight: "6px",
                  }}
                >
                  {"<"}
                </button>
                {renderPageNumbers()}
                <button
                  onClick={() => handlePageChange(page + 1)}
                  disabled={page >= pageCount - 1}
                  style={{
                    fontFamily: "Rubik",
                    fontSize: "20px",
                    marginLeft: "6px",
                  }}
                >
                  {">"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Snackbar
        open={showErrorSnackbar}
        autoHideDuration={6000}
        onClose={() => setShowErrorSnackbar(false)}
      >
        <Alert severity={snackbarSeverity}>{snackbarMessage}</Alert>
      </Snackbar>
       <Dialog open={!!editData} onClose={() => setEditData(null)}>
                <DialogTitle>Edit Vehicle IoT Details</DialogTitle>
                <DialogContent>
                  <TextField
                    margin="dense"
                    label={
                      <span>
                        IMEI<span style={{ color: "red" }}> *</span>
                      </span>
                    }
                    fullWidth
                    inputProps={{
                      maxLength: 15,
                      inputMode: "numeric",
                      pattern: "[0-9]*",
                    }}
                    value={editForm.imei}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, ""); // Allow only digits
                      setEditForm({ ...editForm, imei: value });
                    }}
                  />
                  <TextField
                    margin="dense"
                    label={
                      <span>
                        BLE MAC<span style={{ color: "red" }}> *</span>
                      </span>
                    }
                    fullWidth
                    value={editForm.bleMac}
                    onChange={(e) =>
                      setEditForm({ ...editForm, bleMac: e.target.value })
                    }
                  />
                  <TextField
                    margin="dense"
                    label={
                      <span>
                        MSISDN<span style={{ color: "red" }}> *</span>
                      </span>
                    }
                    fullWidth
                    value={editForm.msisdn}
                    onChange={(e) =>
                      setEditForm({ ...editForm, msisdn: e.target.value })
                    }
                  />
                  <TextField
                    margin="dense"
                    label={
                      <span>
                        IoT Type<span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    fullWidth
                    value={editForm.iotType}
                    onChange={(e) =>
                      setEditForm({ ...editForm, iotType: e.target.value })
                    }
                  />
                </DialogContent>
                <DialogActions>
                  <Button onClick={() => setEditData(null)} sx={{ color: "red" }}>
                    Cancel
                  </Button>
                  <Button
                    onClick={handleUpdateIoTDetails}
                    variant="contained"
                    sx={{ backgroundColor: "#00CD5B" }}
                    disabled={
                      !editForm.imei ||
                      editForm.imei.length !== 15 ||
                      !editForm.bleMac ||
                      !editForm.msisdn ||
                      !editForm.iotType
                    }
                  >
                    Submit
                  </Button>
                </DialogActions>
              </Dialog>
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <DialogTitle>{selectedPlan?.planSelected} Plan</DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="textSecondary">
            Do you want to approve or reject the plan for user:{" "}
            {selectedPlan?.name}?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              if (selectedPlan) {
                handlePlanStatusUpdate(selectedPlan.userId, "APPROVED");
              }
              setOpenDialog(false);
            }}
            variant="contained"
            style={{
              backgroundColor: "#05B97D",
              color: "#fff",
              textTransform: "none",
              borderRadius: "20px",
              padding: "5px 25px",
            }}
          >
            Accept
          </Button>
          <Button
            onClick={() => {
              if (selectedPlan) {
                handlePlanStatusUpdate(selectedPlan.userId, "REJECTED");
              }
              setOpenDialog(false);
            }}
            variant="contained"
            style={{
              backgroundColor: "#F94932",
              color: "#fff",
              textTransform: "none",
              borderRadius: "20px",
              padding: "5px 25px",
            }}
          >
            Reject
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default FleetDailyReport;
